import type { IconAsset } from '../Icon.types';

const code = (
  <path
    d='M35.4856 0.499146L33.9753 1.67481L39.7457 6.16673H0.161499V7.83041H39.7457L33.9753 12.3223L35.4856 13.5008L43.8384 6.99857L35.4856 0.499146Z'
    fill='currentColor'
  />
);

export const longArrow: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
